import 'COMMON';
import { oLike } from 'Lib/like/like';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/personages-slider/personages-slider';
import 'Bem/site/spoiler/spoiler';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/book/book';
import 'Bem/site/publications-slider/publications-slider';
import 'Bem/site/filter-formats/filter-formats';
import 'Bem/site/radio/radio';
import 'Bem/site/authors-slider/authors-slider';
import 'Bem/site/single-book/single-book';
import 'Bem/site/collections-slider/collections-slider';
import 'Bem/site/checkbox/checkbox';
import 'Bem/site/search-content/search-content';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';

const $body = $('body');

svgSpriteLoader('/site/personages/svg/sprite.svg?v=20180320');
oLike.init('.js-book-like');

$body.on('eksmoPagenavAjax', () => {
    oLike.init('.js-book-like');
});

// Фильтр персонажей
$body.on('eksmoSetMMenu', '.js-m-menu-personages', function () {
    const $thisMMenu = $(this);
    const sRadio = '.js-m-menu-personages-radio';
    const sMenuBooksSubmit = '.js-m-menu-personages-radio-submit';
    const cBtnDisabled = 'btn_disabled';

    function setUrl() {
        const $submitLink = $thisMMenu.find(sMenuBooksSubmit).first();

        if ($submitLink.length) {
            $thisMMenu.find(sRadio).each(function () {
                const $this = $(this);

                if ($this.find('input:checked').length) {
                    const dataHref = $this.attr('data-href');

                    if (isNoEmptyString(dataHref)) {
                        $submitLink.removeClass(cBtnDisabled);
                        $submitLink.attr('data-href', dataHref);
                    }
                }
            });
        }
    }

    $thisMMenu.on('eksmoChangeRadio', sRadio, setUrl);

    $thisMMenu.on('eksmoHideMMenu', function () {
        $(this).find(sMenuBooksSubmit).addClass(cBtnDisabled);
    });

    $thisMMenu.on('click', sMenuBooksSubmit, function () {
        if ($(this).hasClass('btn_disabled')) {
            return false;
        }

        $thisMMenu.trigger('eksmoMMenuClose');

        return false;
    });
});

// Фильтр книг
$body.on('eksmoSetMMenu', '.js-m-menu-books', function () {
    const $thisMMenu = $(this);
    const sCheckbox = '.js-m-menu-books-checkbox';
    const sRadioFormatLabels = '.js-m-menu-books-radio-format';
    const sRadioPriceLabels = '.js-m-menu-books-radio-price';
    const sMenuBooksSubmit = '.js-m-menu-books-submit';
    const cBtnDisabled = 'btn_disabled';

    function setUrl() {
        const $submitLink = $thisMMenu.find(sMenuBooksSubmit).first();
        const arrUrl = [];

        $thisMMenu.find(sCheckbox).each(function () {
            const $thisCheckbox = $(this);
            const value = $thisCheckbox.find('input:checked').length ? $thisCheckbox.attr('data-m-menu-books-y') : $thisCheckbox.attr('data-m-menu-books-n');

            if (isNoEmptyString(value)) {
                arrUrl.push(value);
            }
        });

        $thisMMenu.find(sRadioFormatLabels).each(function () {
            const $this = $(this);

            if ($this.find('input:checked').length) {
                const data = $this.attr('data-m-menu-books');

                if (isNoEmptyString(data)) {
                    arrUrl.push(data);
                }
            }
        });

        $thisMMenu.find(sRadioPriceLabels).each(function () {
            const $this = $(this);

            if ($this.find('input:checked').length) {
                const data = $this.attr('data-m-menu-books');

                if (isNoEmptyString(data)) {
                    arrUrl.push(data);
                }
            }
        });

        $submitLink.removeClass(cBtnDisabled);
        $submitLink.attr('data-href', `?${arrUrl.join('&')}`);
    }

    $thisMMenu.on('eksmoChangeCheckbox', sCheckbox, setUrl);
    $thisMMenu.on('eksmoChangeRadio', sRadioFormatLabels, setUrl);
    $thisMMenu.on('eksmoChangeRadio', sRadioPriceLabels, setUrl);

    $thisMMenu.on('eksmoHideMMenu', function () {
        $(this).find(sMenuBooksSubmit).addClass(cBtnDisabled);
    });

    $thisMMenu.on('click', sMenuBooksSubmit, function () {
        if ($(this).hasClass(cBtnDisabled)) {
            return false;
        }

        $thisMMenu.trigger('eksmoMMenuClose');

        return false;
    });
});